import slice from './slice';

export const { resetState } = slice.actions;
